// Firebase configuration
/* global firebase */
const firebaseConfig = {
     apiKey: "AIzaSyDkG7DSBhKjNgM8pHogCVmFP35nK9xqajU",
  authDomain: "cycle4tausch.firebaseapp.com",
  projectId: "cycle4tausch",
  storageBucket: "cycle4tausch.firebasestorage.app",
  messagingSenderId: "508295743032",
  appId: "1:508295743032:web:0b13a4900eeff7ec1308cd"
};

// Initialize Firebase
let auth, db, storage, functions;

function initializeFirebase() {
    try {
        firebase.initializeApp(firebaseConfig);
        firebase.analytics();
        
        auth = firebase.auth();
        db = firebase.firestore();
        storage = firebase.storage();
        functions = firebase.functions();
        
        console.log('Firebase initialized successfully!');
        return true;
    } catch (error) {
        console.error('Error initializing Firebase:', error);
        return false;
    }
}

// Helper to access Firebase FieldValue
const getFieldValue = () => {
    if (typeof firebase !== 'undefined' && firebase.firestore) {
        return firebase.firestore.FieldValue;
    }
    throw new Error('Firebase not initialized');
};

export { firebaseConfig, auth, db, storage, functions, initializeFirebase, getFieldValue };